"use strict";
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var authentication_widget_1 = require("@cian/authentication-widget");
var browser_1 = require("@cian/config/browser");
var browser_2 = require("@cian/microservices-tools/telemetry/browser");
var browser_3 = require("@cian/microservices-tools/logger/browser");
var browser_4 = require("@cian/http-api/browser");
var schema_1 = require("./schema");
exports.createContext = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var schema, config, telemetryLogger, logger, httpApi, subdomain;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                schema = schema_1.createConfigSchema();
                config = browser_1.createClientConfig({
                    schema: schema,
                    uniqueConfigKey: 'cian-v16-authentication-frontend',
                });
                return [4 /*yield*/, config.load()];
            case 1:
                _a.sent();
                telemetryLogger = browser_2.clientTelemetry(config);
                logger = browser_3.createLogger(config);
                httpApi = new browser_4.HttpApi({
                    config: config,
                    logger: logger,
                    telemetry: tslib_1.__assign({}, telemetryLogger),
                });
                subdomain = config.get('subdomain', 'www');
                return [2 /*return*/, authentication_widget_1.createContext({
                        httpApi: httpApi,
                        subdomain: subdomain,
                        logger: logger,
                    })];
        }
    });
}); };



//////////////////
// WEBPACK FOOTER
// ./src/browser/initializers/authentication/context.tsx
// module id = 125
// module chunks = 2